/**
 * `decorate()` for the headless half of a decorator node.
 *
 * Every decorator node is split in two: the class registered in
 * `EDITOR_NODES_HEADLESS`, which only has to serialise and export DOM, and its
 * `*Mui` subclass registered in `EDITOR_NODES`, which does the rendering. Only
 * the browser reconciles decorators, so the headless class is never decorated.
 *
 * Returning from here rather than an empty JSX fragment is what keeps React out
 * of the API Worker bundle - see api/no-ui.test.ts.
 */
export function headlessDecorate(): never {
  // `never` so this satisfies every `DecoratorNode<T>`; nothing is rendered.
  return null as never;
}
